/* eslint-disable react/jsx-props-no-spreading */

import BaseCollapsibleTable from 'app/shared-components/CollapsibleTable/BaseCollapsibleTable'
import {
    useSkyNetRoutes,
} from 'app/SkyNetRoutes'
import {
    CommonRoutes,
} from 'app/enums/common.enums'
import NavigatedCollapsibleTable from 'app/shared-components/CollapsibleTable/NavigatedCollapsibleTable'
import {
    CollapsibleTableProps,
} from './CollapsibleTableProps'

export default function CollapsibleTable(props: CollapsibleTableProps) {
    const {
        routeParams,
        ignoreNavigation,
    } = props

    const routes = ignoreNavigation ? [{
        path: CommonRoutes.Index,
        element: <BaseCollapsibleTable {...props} />,
    }] : [{
        path: CommonRoutes.Slash.concat(((routeParams || [
            'actionId',
            'action',
        ]) as string[]).map((route) => {
            return `:${route}?`
        }).join(CommonRoutes.Slash), CommonRoutes.Slash, CommonRoutes.Asterisk),
        element: <NavigatedCollapsibleTable {...props} />,
    }]

    return useSkyNetRoutes({
        routes,
    })
}
